import type { Order, TimestampField } from '@talos/kyoko';

export type OrderTimestampField = keyof Pick<Order, 'SubmitTime' | 'Timestamp' | 'LastTradeTime'> | '';

export const orderTimestampFields: TimestampField<OrderTimestampField>[] = [
  {
    Name: '',
    DisplayName: 'Default',
    Description: 'Returns any orders submitted or updated in the specified period.',
    default: true,
  },
  {
    Name: 'SubmitTime',
    DisplayName: 'Submit Date',
    Description: 'Filters by order submit timestamp.',
    default: false,
  },
  {
    Name: 'Timestamp',
    DisplayName: 'Updated At',
    Description: 'Filters by order update timestamp.',
    default: false,
  },
  {
    Name: 'LastTradeTime',
    DisplayName: 'Last Trade Time',
    Description: 'Filters by the latest trade execution timestamp.',
    default: false,
  },
];
